































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getRecentLessons } from '@/api/educational';
import { TRecentLesson } from '@/types/views/educational';
@Component({})
export default class Recent extends Vue {
    private recentLesson: TRecentLesson[] = []
    private activated () {
        this.getRecentLesson()
    }
    private async getRecentLesson() {
        try {
            this.recentLesson = await getRecentLessons()
        } catch (e) {
            this.$message.error(e.message)
        }
    }
  private renderStyle(x: any) {
    return `background: url(${
      x.headThumbUrl
    }) no-repeat;background-size: cover;`;
  }
}
